import slugify from "./slugify";

export default function (reference) {
  const { _type } = reference;
  let url = "";
  if (_type === "topic") {
    const { section, slug: topicSlug, title: topicTitle } = reference;
    const { slug: sectionSlug } = section;
    let topicSlugCurrent;
    if (topicSlug) {
      topicSlugCurrent = topicSlug.current;
    } else {
      topicSlugCurrent = slugify(topicTitle);
    }
    url = `/${sectionSlug.current}/${topicSlugCurrent}`;
  } else if (_type === "section") {
    const { slug: sectionSlug } = reference;
    url = `/${sectionSlug.current}`;
  } else if (_type === "activity") {
    const { slug, title } = reference;
    let slugCurrent;
    if (slug) {
      slugCurrent = slug.current;
    } else {
      slugCurrent = slugify(title);
    }
    url = `/activities/${slugCurrent}`;
  }
  return url;
}
